// scheduling/components/idd/IDDStepBar.jsx
// The guided flow's header: 1 Budgets -> 2 Dates -> 3 Submit, each with how much is done.
// Steps are soft: any step can be opened at any time.

const STEP_DEFS = [
  { key: 'budgets', n: 1, title: 'Budgets', hint: 'How many hours each job needs' },
  { key: 'dates', n: 2, title: 'Dates', hint: 'When each job starts and is due (internal due dates)' },
  { key: 'submit', n: 3, title: 'Submit', hint: 'Send everything to Practice Engine' },
];

// datesLock: { locked, pending } (iddSteps.datesStepLocked): the Dates step reads "Locked" until
// every job has a budget; it stays clickable.
export default function IDDStepBar({ step, onStep, counts, allSubmitted, datesLock = null }) {
  const done = {
    budgets: counts.budgets,
    dates: counts.dates,
    submit: allSubmitted ? counts.total : counts.ready,
  };
  return (
    <div className="idd-steps" role="tablist" aria-label="Review steps">
      {STEP_DEFS.map((s, i) => {
        const n = done[s.key];
        const complete = counts.total > 0 && n >= counts.total;
        const pct = counts.total > 0 ? Math.round((100 * n) / counts.total) : 0;
        const lockedHere = s.key === 'dates' && !!datesLock?.locked;
        const sub = s.key === 'submit'
          ? (allSubmitted ? 'Submitted ✓' : `${counts.ready} of ${counts.total} ready`)
          : lockedHere ? `Locked: ${datesLock.pending} budget${datesLock.pending !== 1 ? 's' : ''} to go`
          : `${n} of ${counts.total} decided`;
        return (
          <div key={s.key} className="idd-steps-item">
            {i > 0 && <span className="idd-steps-arrow" aria-hidden="true">→</span>}
            <button
              role="tab"
              aria-selected={step === s.key}
              className={`idd-step${step === s.key ? ' idd-step--active' : ''}${complete ? ' idd-step--complete' : ''}${lockedHere ? ' idd-step--locked' : ''}`}
              onClick={() => onStep(s.key)}
              title={lockedHere ? 'Unlocks when every job has a budget (you can still look)' : s.hint}
            >
              <span className="idd-step-num">{complete ? '✓' : s.n}</span>
              <span className="idd-step-text">
                <span className="idd-step-title">{s.title}</span>
                <span className="idd-step-sub">{sub}</span>
              </span>
              <span className="idd-step-bar" aria-hidden="true"><span style={{ width: `${pct}%` }} /></span>
            </button>
          </div>
        );
      })}
    </div>
  );
}
